var _module_exports = "<div class=\"sf-analytics-function-description\">\n  Get the natural logarithm of values.\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/LOG/config.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;